import React from 'react';
import { OrdemDeServicoFormData } from '../../types/ordemServico';
import { PieChart, AlertCircle, DollarSign, Wallet } from 'lucide-react';

interface OsFormTotaisProps {
  formData: OrdemDeServicoFormData;
  setFormData: React.Dispatch<React.SetStateAction<OrdemDeServicoFormData>>;
}

export const OsFormTotais: React.FC<OsFormTotaisProps> = ({
  formData,
  setFormData,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setFormData((prev) => ({ ...prev, ocorrencias: e.target.value }));
  };

  const formatCurrency = (val: number) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val || 0);
  };

  return (
    <div className="space-y-4 pt-2">
      {/* Ocorrências */}
      <div>
        <label className="block text-xs font-bold text-slate-700 uppercase mb-1 flex items-center gap-1">
          <AlertCircle className="w-3.5 h-3.5 text-amber-500" />
          Ocorrências da Ordem de Serviço
        </label>
        <textarea
          name="ocorrencias"
          rows={2}
          value={formData.ocorrencias}
          onChange={handleChange}
          placeholder="Registre ocorrências ou imprevistos durante a execução..."
          className="w-full border border-slate-300 rounded-lg p-2.5 text-sm text-slate-800 focus:ring-2 focus:ring-red-500 outline-none"
        />
      </div>

      {/* Grid dos Totais */}
      <div className="p-4 bg-slate-900 rounded-xl text-white space-y-3">
        <div className="flex items-center gap-2 border-b border-slate-800 pb-2">
          <PieChart className="w-4 h-4 text-red-400" />
          <h4 className="text-xs font-bold uppercase tracking-wider text-slate-300">
            Resumo Financeiro & Fechamento
          </h4>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 pt-1">
          {/* Valor Total O.S */}
          <div className="p-3 bg-slate-800/80 border border-slate-700 rounded-lg">
            <span className="text-2xs font-bold text-slate-400 uppercase block flex items-center gap-1">
              <DollarSign className="w-3 h-3 text-emerald-400" />
              Total O.S
            </span>
            <span className="text-lg font-black text-emerald-400 mt-1 block">
              {formatCurrency(formData.total_os)}
            </span>
          </div>

          {/* Repasse Ajudantes */}
          <div className="p-3 bg-slate-800/80 border border-slate-700 rounded-lg">
            <span className="text-2xs font-bold text-slate-400 uppercase block">
              Repasse Ajudantes
            </span>
            <span className="text-lg font-bold text-slate-200 mt-1 block">
              {formatCurrency(formData.ajudante_repasse)}
            </span>
          </div>

          {/* Repasse Total */}
          <div className="p-3 bg-slate-800/80 border border-slate-700 rounded-lg">
            <span className="text-2xs font-bold text-slate-400 uppercase block flex items-center gap-1">
              <Wallet className="w-3 h-3 text-amber-400" />
              Repasse Total
            </span>
            <span className="text-lg font-bold text-amber-400 mt-1 block">
              {formatCurrency(formData.valor_total_repasses)}
            </span>
          </div>

          {/* Valor Líquido */}
          <div className="p-3 bg-blue-950/80 border border-blue-800 rounded-lg">
            <span className="text-2xs font-bold text-blue-300 uppercase block flex items-center gap-1">
              <DollarSign className="w-3 h-3 text-blue-400" />
              Valor Líquido O.S
            </span>
            <span className="text-lg font-black text-blue-300 mt-1 block">
              {formatCurrency(formData.valor_liquido)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
